if (!customElements.get('country-picker')) {
  class CountryPicker extends HTMLElement {
    constructor() {
      super();
      this.sectionId = document.querySelector('[data-country-picker-section-id]').dataset.countryPickerSectionId;
      this.init();
    }

    async init() {
      // need to use a dynamic section instead of a static one since its included in the header
      // sections--20449899413828__country-picker
      fetch(window.Shopify.routes.root + '?sections=' + this.sectionId, {
        headers: { 'Content-Type': 'application/json', Accept: `application/json` },
      })
        .then((res) => res.text())
        .then((res) => {
          const data = JSON.parse(res)[this.sectionId];
          this.innerHTML = data;
          this.disableLoading();
        });
    }

    disableLoading() {
      this.dataset.state = 'loaded';
      this.querySelectorAll('[data-state="loading"]').forEach((ele) => {
        ele.dataset.state = 'loaded';
      });
    }
  }

  customElements.define('country-picker', CountryPicker);
}
